import React, { useState } from 'react';
import { Layout, Tabs, TabPanel } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useIntls from '@opm/hooks/useIntls';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import { VideoPoint } from '@opm/operationLog/pages';
import BubbleCommon from '@op/components/BubbleCommon';
import { useTranslateHashtagCategory } from '../Hashtag/hooks';
import { videoHeaderTipsMap } from '@opm/components/BubbleCommon';
import ScrollBottomList from '@opm/components/ScrollBottomList';
import { ClassSpecial } from '@op/constants/common';
import useTabHistory from '@op/hooks/useTabHistory';
import TabBar from './tabs';
import { TAB_CONFIG, DEFAULT_TAB } from './tabs/constants';
import { VideoTranslateContext } from './context';
import type { LanguageType } from '@op/types/common';
import './index.scss';

const { Content } = Layout;

export default function Video() {
  // DBOM_POINT.useInitPage({ buriedPoint: VideoPoint });

  const { intl } = useIntls();
  const { backCondConfig, translateCategory } = useTranslateHashtagCategory({
    type: 'video',
  });

  // Tab 状态提升到页面入口，同步到 URL query
  const { tab: activeKey, onActive } = useTabHistory({
    defaultValue: DEFAULT_TAB,
    key: 'tab',
    removeKeys: ["shortid"]
  });

  // Tab 切换回调：同步更新 URL 并打点
  const handleTabActive = (tabInfo: { id: string; }) => {
    onActive(tabInfo);
  };

  // 翻译语言状态，通过 Context 下发给各 Tab
  const [language, setLanguage] = useState<LanguageType>('origin');

  return (
    <VideoTranslateContext.Provider value={{ language, setLanguage }}>
      <ScrollBottomList>
        <Content className="dbom-videos-page">
          <Content.Header
            className="contentHead-normal"
            title={intl({ id: 'Video' })}
            subtitle={
              <div className="dbo-header-subtitle">
                {intl({ id: 'Data Update' })}
                <BubbleCommon showIcon={false} tipsMap={videoHeaderTipsMap}>
                  <TipContext className="title-tip" placement="bottom" />
                </BubbleCommon>
              </div>
            }
          >
            <div className="header-tab">
              <TabBar activeKey={activeKey} onActive={handleTabActive} />
            </div>
          </Content.Header>
          <Tabs
            className={ClassSpecial.TAB_NONE}
            activeId={activeKey}
            onActive={handleTabActive}
          >
            {TAB_CONFIG.map(tab => (
              <TabPanel key={tab.key} id={tab.key}>
                <tab.component
                  backCondConfig={backCondConfig}
                  translateCategory={translateCategory}
                />
              </TabPanel>
            ))}
          </Tabs>
        </Content>
      </ScrollBottomList>
    </VideoTranslateContext.Provider>
  );
}
